
class Configuracao {  
    public static campos = () => {
        return [   
            {
                nome: "nome",
                type: "text",
                label: "Chave",
                sm: 12 ,
                lg: 12, 
                disabled: false
            },   
            {
                nome: "valor",
                type: "text",
                label: "Valor",
                sm: 12 ,
                lg: 12, 
                disabled: false
            },  
        ];
    }   
}
  
export   {   Configuracao };
